import type {ReactElement} from 'react';
import React from 'react';
import {BaseRemoveColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-remove-color-panel';
import type {RGBA} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideitemRemoveColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const removeColorValue = useGetKeyFromEffectsOfActiveSlideItem('removeColorValue');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (!removeColorValue) {
    throw new Error('remove color value is undefined for active slide item');
  }

  const updateRemoveColor = (removeColorValue: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          removeColorValue,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseRemoveColorPanel removeColorValue={removeColorValue} onUpdateRemoveColor={updateRemoveColor} />;
}
